import { z } from 'zod'

import { ProblemSchema } from '~/@entities/Problem'

/***************** 유형칩 난이도 *****************/
export const CONCEPT_CHIP_TYPE = ['개념', '기본', '심화'] as const

export const ConceptChipTypeSchema = z.enum(CONCEPT_CHIP_TYPE)
export type ConceptChipType = z.infer<typeof ConceptChipTypeSchema>

export const ConceptChipSchema = z.object({
  conceptChipId: z.number(),
  // 서버는 string 으로 내주지만 실제 값은 개념·기본·심화 셋뿐이다. 좁히는 근거는 경계 검증이 만든다.
  conceptChipType: ConceptChipTypeSchema,
  orderingNumber: z.number(),
  orderNumber: z.number(),
  recommended: z.boolean(),
  bigChapterId: z.number(),
  bigChapterName: z.string(),
  middleChapterId: z.number(),
  middleChapterName: z.string(),
  littleChapterId: z.number(),
  littleChapterName: z.string(),
  conceptId: z.number(),
  conceptName: z.string(),
  // 유형칩을 대표하는 문제. 대표 문제가 지정되지 않은 칩은 null 이다.
  repProblem: ProblemSchema.nullable(),
})
export type ConceptChip = z.infer<typeof ConceptChipSchema>

export type ConceptChipCountByType = Record<ConceptChipType, number>
